module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="tl-tabs-labels-region"></div>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/tabs/tabs.html
 ** module id = 285
 ** module chunks = 1 2 3 7 32 39 46
 **/